import _ from "lodash";
import React, { Fragment } from "react";
import { Input } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  setDataThunk,
  setSelectedFiles,
  updateDataConfig,
} from "../../services/store";
import { EyeFilled, EyeInvisibleFilled } from "@ant-design/icons";
import Upload from "../../lib/Upload";

const { TextArea } = Input;

const GeneralPanel = ({ selectedElement, handlePropertyChange, isGlobal }) => {
  const dispatch = useDispatch();
  const { data, layoutConfig = {} } = useSelector((state) => state.grid);

  const orderedPropertiesList = _.orderBy(
    Object.keys(data),
    (key) => {
      if (key.includes("_#")) {
        const [start, index] = key.split("_#");
        return `${layoutConfig[start]?.["order"]}.${index}`;
      }
      return layoutConfig[key]?.["order"];
    },
    "asc",
  );

  return (
    <div>
      {orderedPropertiesList.map((key) => {
        const config = _.get(layoutConfig, key, {});
        const maxRows = _.get(config, "rows", 6);
        const visible = _.get(config, "visible", true);

        return (
          <div className="flex flex-col items-start gap-1 mb-3" key={key}>
            <label
              className={`text-xs font-bold ${visible ? "" : "text-gray-400"}`}
            >
              {key}&nbsp;
              <span
                className="cursor-pointer"
                onClick={() =>
                  dispatch(updateDataConfig({ key, property: "visible" }))
                }
              >
                {visible ? <EyeFilled /> : <EyeInvisibleFilled />}
              </span>
            </label>
            {visible && (
              <Fragment>
                {key === "files" ? (
                  <Upload
                    files={data.files}
                    onChange={(files) => dispatch(setSelectedFiles(files))}
                  />
                ) : (
                  <TextArea
                    data-gramm="false"
                    autoSize={{ minRows: 2, maxRows }}
                    placeholder={key}
                    value={data[key]}
                    onChange={(e) =>
                      dispatch(setDataThunk({ [key]: e.target.value }))
                    }
                    spellCheck={false}
                  />
                )}
              </Fragment>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default GeneralPanel;
